import {gsap} from "../LibrariesImport";

export default class BlockPartIndustries {
	static init() {
		this.blocks = document.querySelectorAll(".block-part-industries");

		if (!this.blocks) {
			return;
		}

		this.buildBlocks();
	}

	static buildBlocks() {
		this.blocks.forEach(block => {
			this.initSlider(block);
		});
	}

	static initSlider(block) {
		const scrollable = block.querySelector(".industry-scrollable");
		new Swiper(scrollable, {
			loop: false,
			grabCursor: true,
			slidesPerView: "auto",
			spaceBetween: 0,
			speed: 500,
			touchEventsTarget: "container",
			mousewheel: {
				enabled: true,
				releaseOnEdges: true,
				forceToAxis: true,
			}
		});
	}
}
